import { combineReducers } from 'redux'
import keycloak from './keycloak-reducers'

const rootReducer = combineReducers({
  keycloak,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js